import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../../services/user.service";
import {Localiser} from "../../../services/localiser";
import {plano} from "../../../models/plano";
import {zona} from "../../../models/zona";
import {ZonaService} from "../../../services/zona.service";
import {luminaria} from "../../../models/luminaria";
import {LuminariaService} from "../../../services/luminaria.service";
import { ReglasService } from 'src/app/services/reglas.service';
import { regla } from 'src/app/models/regla';
import { ProyectoService } from 'src/app/services/proyecto.service';
import {Roles} from '../../../commons/util';

@Component({
  selector: 'app-new-zone',
  templateUrl: './new-zone.component.html',
  styleUrls: ['./new-zone.component.css']
})
export class NewZoneComponent implements OnInit {

  nombre = "";
  color = '#18264F';
  descripcion = "";
  planos: Array<plano> = [];
  planoSelected = undefined;
  zonaEdit;
  errorMessage = "";

  addLuminarias: boolean = false;
  luminariasZonaReal: Array<luminaria> = [];
  luminariasZona: Array<luminaria> = [];
  luminariasPlanoReal: Array<luminaria> = [];
  luminariasPlano: Array<luminaria> = [];
  reglas: Array<regla> = [{
    idRegla: 0,
    nombre: this.localiser.get("zones.editZone.noRuleSelected"),
    activa: false,
    min_resto: 0,
    max_resto: 100,
    zonas: [],
    days_of_week: {}
  }];
  reglaSelected: regla = undefined;
  searcherLuminariasIn = "";
  searcherLuminariasOut = "";

  updatedSmt: boolean = false;

  constructor(public dialogRef: MatDialogRef<NewZoneComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              public localiser: Localiser,
              public zonaService: ZonaService,
              public luminariaService: LuminariaService,
              public reglasService: ReglasService,
              public proyectoService: ProyectoService,
              public user: UserService
            ) { }

  ngOnInit(): void {
    this.planos = this.data.planos;
    this.zonaEdit = this.data.zona;
    if (this.zonaEdit != undefined) {
      this.nombre = this.zonaEdit.nombre;
      this.color = this.zonaEdit.color;
      this.descripcion = this.zonaEdit.descripcion;
      this.planoSelected = this.planos.find(plano => plano.idPlano == this.zonaEdit.idPlano);
      this.luminariasZonaReal = this.zonaEdit.luminarias;
      this.luminariasPlanoReal = this.data.luminarias.filter(
        luminaria => luminaria.idZona == '-1' && luminaria.idPlano == this.zonaEdit.idPlano &&
                      this.luminariasZonaReal.indexOf(luminaria) == -1);
      this.luminariasZona = this.luminariasZonaReal;
      this.luminariasPlano = this.luminariasPlanoReal;
    }
    this.reglasService.getPendingByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.reglas = this.reglas.concat(<Array<regla>> result);
      this.reglaSelected = this.reglas[0];

      if (this.zonaEdit != undefined) {
        for (let rule of this.reglas) {
          let id_regla_zona_actual = undefined;

          for (const zona of rule.zonas) {
            if (zona.id == this.zonaEdit.id) {
              id_regla_zona_actual = rule.idRegla;
              break;
            }
          }

          if (id_regla_zona_actual != undefined && id_regla_zona_actual == rule.idRegla) {
            this.reglaSelected = rule;
            break;
          }
        }
      }
    })
  }

  newZone() {
    this.errorMessage = "";
    if (this.nombre.length > 0 && this.planoSelected != undefined) {
      let zona: zona = {
        id: 'id',
        regla: this.reglaSelected.idRegla,
        idPlano: this.planoSelected.idPlano,
        nombre: this.nombre,
        color: this.color,
        descripcion: this.descripcion,
        nodos_confirmados: 0,
        nodos_total: 0
      }
      this.luminariasPlanoReal = this.data.luminarias.filter(
        luminaria => luminaria.idZona == '-1' && luminaria.idPlano == this.planoSelected.idPlano);
      this.luminariasPlano = this.luminariasPlanoReal;
      this.zonaService.add(zona).subscribe(result => {
        this.updatedSmt = true;
        this.zonaEdit = JSON.parse(result);
        this.toAddLuminarias();
      });
    } else {
      if (this.nombre.length <= 0 && this.planoSelected == undefined) {
        this.errorMessage = this.localiser.get("zones.emptyName&Floorplan");
      } else if (this.nombre.length <= 0) {
        this.errorMessage = this.localiser.get("zones.emptyName");
      } else if (this.planoSelected == undefined) {
        this.errorMessage = this.localiser.get("zones.emptyFloorplan");
      }
    }
  }

  updateZone() {
    this.errorMessage = "";
    if (this.nombre.length > 0 && this.planoSelected != undefined) {
      this.zonaEdit.nombre = this.nombre;
      this.zonaEdit.color = this.color;
      this.zonaEdit.descripcion = this.descripcion;
      this.zonaEdit.idPlano = this.planoSelected.idPlano;
      let that = this;
      this.zonaEdit.regla = this.reglaSelected.idRegla;
      this.zonaService.update(this.zonaEdit).subscribe(result => {
        that.dialogRef.close(true);
      });
    } else {
      if (this.nombre.length <= 0 && this.planoSelected == undefined) {
        this.errorMessage = 'El nombre y el plano no pueden estar vacíos';
      } else if (this.nombre.length <= 0) {
        this.errorMessage = 'El nombre no puede estar vacío';
      } else if (this.planoSelected == undefined) {
        this.errorMessage = 'El plano no puede estar vacío';
      }
    }
  }

  addLuminariaToZona(luminaria: luminaria) {
    this.updatedSmt = true;
    this.luminariaService.infoUpdate(luminaria.idDispositivo, luminaria.nombre, luminaria.numSerie,
      luminaria.fechaInstalacion, luminaria.tieneEmergencia, luminaria.ledModelo, luminaria.nominalLux,
      luminaria.consumoPorHora, luminaria.idProyecto, luminaria.idPlano, this.zonaEdit.id).subscribe(result => {
        this.luminariasPlanoReal = this.luminariasPlanoReal.filter(
          luminariaFil => luminariaFil.idDispositivo != luminaria.idDispositivo);
        this.luminariasZonaReal.push(luminaria);
      this.luminariasPlano = this.luminariasPlanoReal;
      this.luminariasZona = this.luminariasZonaReal;
    })
  }

  removeLuminariaToZona(luminaria: luminaria) {
    this.updatedSmt = true;
    this.luminariaService.infoUpdate(luminaria.idDispositivo, luminaria.nombre, luminaria.numSerie,
      luminaria.fechaInstalacion, luminaria.tieneEmergencia, luminaria.ledModelo, luminaria.nominalLux,
      luminaria.consumoPorHora, luminaria.idProyecto, luminaria.idPlano, '-1').subscribe(result => {
      this.luminariasZonaReal = this.luminariasZonaReal.filter(
        luminariaFil => luminariaFil.idDispositivo != luminaria.idDispositivo);
      this.luminariasPlanoReal.push(luminaria);
      this.luminariasPlano = this.luminariasPlanoReal;
      this.luminariasZona = this.luminariasZonaReal;
    })
  }

  toAddLuminarias() {
    this.addLuminarias = true;
  }

  backToEdit() {
    this.addLuminarias = false;
  }

  searcherLuminariasFuncIn() {
    this.luminariasZona = this.luminariasZonaReal.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminariasIn.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminariasIn.toLowerCase())));
  }

  searcherLuminariasFuncOut() {
    this.luminariasPlano = this.luminariasPlanoReal.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminariasOut.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminariasOut.toLowerCase())));
  }

  selectPlano(event) {
    this.planoSelected = this.planos.find(plano => plano.idPlano == event.value.idPlano);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.updatedSmt);
  }

  public readonly Roles = Roles;
}
